import { TourActTempBookingSnapshot } from "@/types/booking/checkout";

export type TourActBookingKeyPayload = {
  activityId: string;
  contextKey: string;
  key: string;
};

export function isTourActTempBookingSnapshot(
  raw: unknown,
): raw is TourActTempBookingSnapshot {
  if (!raw || typeof raw !== "object") return false;
  const snapshot = raw as Record<string, unknown>;
  return (
    snapshot.svcType === "tour_act" &&
    typeof snapshot.tour_act === "object" &&
    snapshot.tour_act !== null &&
    Array.isArray(snapshot.tickets)
  );
}